import React from "react";
import { Link } from "react-router-dom";
import Footer from "../Sub/Footer";
import { Row, Col } from "react-bootstrap";
import NavbarWithDrawer from "../Sub/NavbarWithDrawer";

const Contact = () => {
  return (
    <>
      <NavbarWithDrawer />
      <div className="container-fluid mb-5 mt-5">
        <div className="page-main p-5 mbl-pedding-10">
          <div className="section__head d-md-flex justify-content-between mb-40">
            <div className="section__title">
              <h1>
                Contact <span>Us</span>
              </h1>
            </div>
          </div>
          <Row className="align-item-center">
            <Col md={6} className="mbl-pedding-10 p-5">
              <p><b>Phone:</b> {process.env.REACT_APP_SUPPORT_PHONE}</p>
              <p><b>Email:</b> <a href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}>{process.env.REACT_APP_SUPPORT_EMAIL}</a></p>
              <p><b>Address:</b> {process.env.REACT_APP_COMPANY_ADDRESS}</p>
              <hr />
              <p className="mb-1"><b>Policies</b></p>
              <ul className="list-unstyled">
                <li><Link className="theme-link" to="/privacy-policy">Privacy Policy</Link></li>
                <li><Link className="theme-link" to="/child-safety">Child Safety Standards</Link></li>
                <li><Link className="theme-link" to="/term-and-conditions">Terms &amp; Conditions</Link></li>
              </ul>
            </Col>
          </Row>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
